import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericDialogComponent } from '../../shared/generic-dialog/generic-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { AuthService } from '../../shared/services/auth.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { SubTasksDialogComponent } from '../sub-tasks-dialog/sub-tasks-dialog.component';
import { Permission } from '../../shared/security/permission';


@Component({
  standalone: false,
  selector: 'app-sub-tasks',
  templateUrl: './sub-tasks.component.html',
  styleUrls: ['./sub-tasks.component.css']
})
export class SubTasksComponent implements OnInit {

  Permission = Permission 
  variables: any;
  arr1: any = [];
  // Form and sub form, needed to link parent form with this component form.
  form: any;
  subForm: any;

  dragDisabled = true;

  @Input() listSubTasks: any = []//List of action type choosen by the user.
  @Input() canEditCatalog: boolean = false;

  listActionByType: any = []; //List of action items filtered by type
  alreadyInCatalog: any[] = [];

  preDefinedActions: any = []; // List of pre-defined action items

  constructor(
    private _formBuilder: FormBuilder,
    private ctrlContainer: FormGroupDirective,
    private dialog: MatDialog,
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private UsersManagementService: UsersManagementService,
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.preDefinedActions = [
      //{...} ir pegar do catalogo
      { name: this.variables.other }
    ];


    //Link sub form and form
    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.form = this.ctrlContainer.form;
    this.form.addControl("formGroup6", this.subForm)
  }


  ngOnChanges(changes: SimpleChanges) {
    this.alreadyInCatalog = changes.listSubTasks.currentValue
  }

  openDialogProject() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listSubTasks;

    if (arrAll && arrAll.length != 0) {
      for (var i = 0; i < arrAll.length; i++) {
        this.arr1.push(arrAll[i].name);
      }
    }

    // Prepare data to be passed to dialog component
    const data = {
      title: this.variables.addSubTask,
      list: this.preDefinedActions,
      listInDB: this.alreadyInCatalog,
      isEdit: false,
      effort: this.variables.hours,
      isSubTask: true,
    }
    let dialogRef = this.dialog.open(SubTasksDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      //Add item to array
      if (result) {
        const Action = {
          name: result.data.subTaskName
        }
        if (!this.listSubTasks) {
          this.listSubTasks = [];
        }
        this.listSubTasks.push(Action);
      }
    })
  }


  openDialogEditProject(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listSubTasks;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].name);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }

    //Prepare data to be passed to dialog component
    item.title = this.variables.changeSubTask + ': ' + item.name

    const data = {
      title: item.title,
      isEdit: true,
      item: item,
      listInDB: this.alreadyInCatalog,
      isSubTask: true,
    }

    let dialogRef = this.dialog.open(SubTasksDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      // Get result and update item on the arr
      if (result?.data) {

        this.listSubTasks.forEach((v: any) => {
          if (v.name === item.name) {
            v.name = result.data.subTaskName;
          }
        })
        this.infoBar.showSnackbar(this.variables.subtaskEditedSuccessfully, ['successful-snackbar'], 4000);

      }

    })
  }


  openDialogRemove(name: any) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {

        const index = this.listSubTasks.findIndex((item: any) => item.name === name);
        if (index !== -1) {
          this.listSubTasks.splice(index, 1);
        }

        this.infoBar.showSnackbar(this.variables.subtaskRemovedSuccessfully, ['successful-snackbar'], 4000);
      }
    });
  }

  dropTable(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.listSubTasks, event.previousIndex, event.currentIndex);
  }


  leave() {
    // Set message for pop up
    let local_data = {
      message: this.variables.sureOutMesage
    }
    // Open pop up
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: local_data
    });

    dialogRef.afterClosed().subscribe(result => {

      //Leave backoffice catalog
      if (result.data) {
        this.router.navigate(['/dashboard']);
      }

    });
  }
}
